import { graphql } from "gatsby";
import React from "react";
import ProcessedImage from "../../../components/common/ProcessedImage/ProcessedImage";
import { Colours } from "../../../utils/colours";
import WrappedSection from "../../WrappedSection/WrappedSection";
import * as styles from "./ParagraphAlignedImageAndText.module.scss";
interface ParagraphAlignedImageAndTextProps {
	htmlText: string;
	imagePosition: "left" | "right";
	image: DogsTrust.MediaImageProps;
}

export const getParagraphAlignedImageAndTextProps = ({
	field_text,
	field_image_position,
	relationships: {
		field_featured_image: { field_media_image },
	},
}: Queries.ParagraphAlignedImageAndTextDataFragment): ParagraphAlignedImageAndTextProps => ({
	htmlText: field_text.value,
	imagePosition: !field_image_position
		? "left"
		: (field_image_position as "left" | "right"),
	image: { src: field_media_image.uri, alt: field_media_image.alt },
});
export const ParagraphAlignedImageAndText: React.FC<
	ParagraphAlignedImageAndTextProps
> = ({ htmlText, imagePosition = "left", image }) => {
	return (
		<WrappedSection
			sectionName="ParagraphAlignedImageAndText"
			sectionColour={Colours.SANDY_FUR}
			customBorder="CurvedBorderBottom"
		>
			<div className={styles.alignedimageandtext}>
				<div
					className={
						imagePosition === "left" ? styles.textright : styles.textleft
					}
					// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
					dangerouslySetInnerHTML={{
						__html: htmlText,
					}}
				/>
				<div
					className={
						imagePosition === "left"
							? styles.imagecontainerleft
							: styles.imagecontainerright
					}
				>
					<ProcessedImage
						src={image.src}
						dimensions="400x300"
						width={400}
						height={300}
						alt={image.alt}
						loading={"lazy"}
					/>
				</div>
			</div>
		</WrappedSection>
	);
};

export const fragment = graphql`
    fragment ParagraphAlignedImageAndTextData on paragraph__aligned_image_and_text {
        __typename
        id
        field_text {
            value
        }
        field_image_position
        relationships {
            field_featured_image {
                ...MediaImageData
            }
        }
    }
`;
